import React from 'react';
import styled from '@emotion/styled';

interface ProductSizeInfoIconProps {
  onClick: () => void;
  isVisible: boolean;
}

const SizeInfoIcon =
  'https://cf.image-farm.s.zigzag.kr/original/cms/2025/12/28/202512281341006305_017313.png?format=webp&quality=80';

export const ProductSizeInfoIcon: React.FC<ProductSizeInfoIconProps> = ({ onClick, isVisible }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Container onClick={onClick}>
      <IconImage src={SizeInfoIcon} alt='사이즈 정보 아이콘' />
    </Container>
  );
};

const Container = styled.button`
  position: relative;
  top: -1px;
  display: block;
  box-sizing: border-box;
  height: 42px;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const IconImage = styled.img`
  width: 24px;
  height: 24px;
  display: block;
`;
